import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IncomingStocksTable from './IncomingStocksTable';
import IncomingStockModal from './IncomingStockModal';
import { incomingStockService } from '../services/incomingStockService';
import './incomingStocksNew.css';
import { saveAs } from 'file-saver';
import menuitemutil from '../../js/admin/menuitem';
import { get, getLocale, confirmDialog } from '../../js/auth';
import auth from '../../js/auth';

class IncomingStocksContainer extends Component {
            // Helper to filter stocks by status
            getStatusForStock(stock) {
                if (stock.draft) return 'draft';
                const entries = stock.entries || [];
                const products = this.props.categories ? menuitemutil.getFlatMenuItems([], this.props.categories) : [];
                let linked = 0, ignored = 0, newCount = 0;
                entries.forEach(entry => {
                    const ignoredEntry = entry.ignored === true;
                    const menuItemId = entry.menuItem && entry.menuItem.id;
                    const hasProduct = products.some(p => p.id === menuItemId);
                    if (hasProduct) {
                        linked++;
                    } else if (ignoredEntry) {
                        ignored++;
                    } else {
                        newCount++;
                    }
                });
                if (newCount > 0) return 'new';
                if (linked > 0) return 'linked';
                if (ignored > 0) return 'ignored';
                return 'none';
            }

            getStatusFilteredStocks() {
                const { incomingStocks } = this.state;
                const statusFilter = this.props.statusFilter || 'all';
                if (statusFilter === 'all') return incomingStocks;
                return incomingStocks.filter(stock => this.getStatusForStock(stock) === statusFilter);
            }
        componentDidUpdate(prevProps) {
            // If dateRange prop changes, reload stocks
            if (
                this.props.dateRange &&
                (
                    !prevProps.dateRange ||
                    this.props.dateRange.startDate?.valueOf() !== prevProps.dateRange.startDate?.valueOf() ||
                    this.props.dateRange.endDate?.valueOf() !== prevProps.dateRange.endDate?.valueOf()
                )
            ) {
                this.applyFilters({
                    dateFrom: this.props.dateRange.startDate?.toDate(),
                    dateTo: this.props.dateRange.endDate?.toDate()
                });
            }
        }
    constructor(props) {
        super(props);

        this.state = {
            incomingStocks: [],
            selectedStock: null,
            isModalVisible: false,
            modalMode: 'view', // 'view', 'edit', 'new'
            isLoading: false,
            filters: {
                dateFrom: null,
                dateTo: null,
                supplier: null,
                invoice: '',
                deliveryNote: '',
                product: null
            },
            error: null
        };

        this.tableRef = React.createRef();
        this.modalRef = React.createRef();
        this.fileInputRef = React.createRef();
        
        // State for uploaded data - exact replica of original
        this.uploadeddata = {
            entries: []
        };
        this.fileInputRef = React.createRef();
        
        // State for uploaded data - exact replica of original
        this.uploadeddata = {
            entries: []
        };
    }

    componentDidMount() {
        // Apply date range from props first
        if (this.props.dateRange) {
            this.applyFilters({
                dateFrom: this.props.dateRange.startDate?.toDate(),
                dateTo: this.props.dateRange.endDate?.toDate()
            });
        } else {
            this.loadIncomingStocks();
        }
        this.setupKeyboardHandlers();
    }

    componentWillUnmount() {
        this.removeKeyboardHandlers();
    }

    setupKeyboardHandlers = () => {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    removeKeyboardHandlers = () => {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        // Implement keyboard shortcuts similar to jQuery version
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.tagName === 'TEXTAREA') {
            return;
        }

        switch (e.key) {
            case 'Delete':
                if (this.state.selectedStock && !this.state.isModalVisible) {
                    this.deleteIncomingStock();
                    e.preventDefault();
                }
                break;
            case 'Enter':
                if (!this.state.isModalVisible && this.state.selectedStock) {
                    this.editIncomingStock();
                    e.preventDefault();
                }
                break;
            case 'F2':
                if (this.state.selectedStock && !this.state.isModalVisible) {
                    this.editIncomingStock();
                    e.preventDefault();
                }
                break;
            default:
                break;
        }
    }

    loadIncomingStocks = async () => {
        try {
            const filters = this.state.filters;
            const data = await incomingStockService.getIncomingStocks({
                from: filters.dateFrom ? filters.dateFrom.getTime() : null,
                to: filters.dateTo ? filters.dateTo.getTime() : null,
                supplier: filters.supplier,
                invoice: filters.invoice,
                deliveryNote: filters.deliveryNote,
                menuitem: filters.product
            });

            // Handle different possible response structures
            const stocks = data?.data || data || [];

            this.setState({
                incomingStocks: stocks,
                isLoading: false
            });
        } catch (error) {
            console.error('Failed to load incoming stocks:', error);
            this.setState({
                error: 'Failed to load incoming stocks',
                isLoading: false
            });
        }
    }

    applyFilters = (newFilters) => {
        this.setState({
            filters: { ...this.state.filters, ...newFilters }
        }, () => {
            this.loadIncomingStocks();
        });
    }

    handleDateRangeChange = (startDate, endDate) => {
        this.applyFilters({
            dateFrom: startDate?.toDate(),
            dateTo: endDate?.toDate()
        });
    }

    // Exact replica of upload click handler from jQuery version
    handleUpload = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.setAttribute("files", "");
            this.fileInputRef.current.value = null;
            this.fileInputRef.current.click();
        }
    }

    // Exact replica of file change handler from jQuery version
    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file || file === "") return;
        
        const reader = new FileReader();
        
        reader.addEventListener("load", () => {
            try {
                localStorage.input_price = "net_unit_price";
                const workbook = window.XLSX.read(reader.result, { type: "binary" });
                
                workbook.SheetNames.forEach(sheet => {
                    let rowObject = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
                    
                    this.uploadeddata = {
                        entries: []
                    };
                    
                    // Get VAT categories using the same method as original
                    this.getVATCategories(vats => {
                        this.getStores(stores => {
                            rowObject.map(row => {
                                //this.getMenuItem(row.id, menuItem => {
                                    Object.keys(row).filter(key => key.startsWith("s_") && row[key] != "0").forEach(key => {
                                        const storeName = key.substring(2);
                                        const store = stores.find(s => s.name === storeName);
                                        let vat = undefined;
                                        if (row.vat) {
                                            vat = vats.find(v => v.percent === Number(row.vat));
                                        }
                                        if (store)
                                            this.uploadeddata.entries.push({
                                                ignored: false,
                                                original_quantity: row[key],
                                                menuItem: { id: row.id  },
                                                quantityType: row.quantityType,
                                                quantity: row["inventory quantity unit"],
                                                store: store,
                                                count: row[key],
                                                net_unit_price: row.cost,
                                                brutto_unit_price: isNaN(row.vat) ? undefined : row.cost * (100 + row.vat) / 100,
                                                net_price: isNaN(row.vat) ? undefined : row[key] * row.cost * (100 + row.vat) / 100,
                                                brutto_price: isNaN(row.vat) ? undefined : row[key] * row.cost * (100 + row.vat) / 100,
                                                vatCategory: vat
                                            });
                                    });
                               // });
                            });
                            // Trigger add button like original
                            this.newIncomingStock();
                        });
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        }, false);
        
        reader.readAsBinaryString(file);
    }

    // Helper methods to match original API calls
    getVATCategories = (callback) => {
        incomingStockService.getVATCategories().then(callback);
    }

    getStores = (callback) => {
        incomingStockService.getStores().then(callback);
    }

    getMenuItem = (id, callback) => {
        get(`adminService/${localStorage.restaurantSelected}/getMenuItem/${id}`)
            .then(callback)
            .catch(error => console.warn(`Failed to get menu item ${id}:`, error));
    }

    handleImportData = async (parsedData) => {
        // Handle imported file data
        if (parsedData && parsedData.entries) {
            const restaurantId = this.props.myStatus?.restaurant_id || 1;
            const linkedEntries = await Promise.all(parsedData.entries.map(async (entry) => {
                if (entry.code) {
                    try {
                        const response = await get(`adminService/${restaurantId}/getDefaultProductForSupplierCode/${entry.code}`);
                        if (response && response.id) {
                            entry.menuItem = { id: response.id };
                        }
                    } catch (err) {
                        // If not found, leave menuItem as is
                    }
                }
                return entry;
            }));
            this.setState({
                selectedStock: {
                    id: null,
                    entries: linkedEntries,
                    supplier: null,
                    date: new Date(),
                    invoice_id: '',
                    delivery_note_id: '',
                    draft: true
                },
                isModalVisible: true,
                modalMode: 'new'
            });
        }
    }

    selectStock = (stock) => {
        this.setState({ selectedStock: stock });
    }

    newIncomingStock = () => {
        // If we have uploaded data, use it for the new stock
        let stockData = null;
        if (this.uploadeddata && this.uploadeddata.entries && this.uploadeddata.entries.length > 0) {
            stockData = {
                id: null,
                supplier: null,
                date: new Date(),
                invoice_id: '',
                delivery_note_id: '',
                entries: this.uploadeddata.entries,
                draft: true
            };
            
            // Clear uploaded data after using it
            this.uploadeddata = { entries: [] };
        }
        
        this.setState({ 
            modalMode: 'new',
            isModalVisible: true,
            selectedStock: stockData
        });
    }
    
    editIncomingStock = () => {
        if (!this.state.selectedStock) return;

        this.setState({
            modalMode: 'edit',
            isModalVisible: true
        }, () => {
        });
    }

    deleteIncomingStock = async () => {
        if (!this.state.selectedStock) return;

       	confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.are_you_sure_you_want_to_delete_the_incoming_stock")).done(async () => {
            try {
                await incomingStockService.deleteIncomingStock(this.state.selectedStock.id);
                await this.loadIncomingStocks();
                this.setState({ selectedStock: null });
            } catch (error) {
                console.error('Failed to delete incoming stock:', error);
                this.setState({ error: 'Failed to delete incoming stock' });
            }
        });
    }

    saveIncomingStock = async (stockData) => {
        try {
            // Process entries to split quantityType format "1000,g" into quantity and quantityType
            // and clean up unnecessary fields
            const processedStockData = {
                supplier: stockData.supplier ? { id: stockData.supplier.id } : null,
                invoice_id: stockData.invoice_id || "",
                delivery_note_id: stockData.delivery_note_id || "",
                date: stockData.date,
                draft: stockData.draft || false,
                entries: stockData.entries.filter(entry => {
                    return !(entry.count === null && !entry.code);
                }).map(entry => {
                    const processedEntry = {
                        count: entry.count,
                        menuItem: entry.menuItem ? {
                            id: entry.menuItem.id,
                            type: entry.menuItem.type || "meal"
                        } : null,
                        code: entry.code,
                        multiplicator: entry.multiplicator || 1,
                        store: entry.store ? { id: entry.store.id } : null,
                        quantity: entry.quantity,
                        vatCategory: entry.vatCategory ? { id: entry.vatCategory.id } : null,
                        quantityType: entry.quantityType,
                        net_unit_price: entry.net_unit_price,
                        brutto_unit_price: entry.brutto_unit_price,
                        net_price: entry.net_price,
                        brutto_price: entry.brutto_price,
                        expiryDate: entry.expiry_date || entry.expiryDate || null,
                        // Preserve ignored status for all entries
                        ignored: entry.ignored || false
                    };

                    // Include id only if it exists (for existing entries)
                    if (entry.id) {
                        processedEntry.id = entry.id;
                    }

                    // Parse quantityType format "quantity;unit" or "quantity,unit"
                    if (processedEntry.quantityType && typeof processedEntry.quantityType === 'string') {
                        const parts = processedEntry.quantityType.split(/[;,]/); // Split by semicolon or comma
                        if (parts.length === 2) {
                            const quantity = parts[0].trim();
                            const unit = parts[1].trim();

                            // Set the extracted quantity and keep only the unit in quantityType
                            processedEntry.quantity = parseFloat(quantity) || 1;
                            processedEntry.quantityType = unit;
                        }
                    }

                    return processedEntry;
                })
            };

            // Include id only if it exists (for existing stock modifications)
            if (stockData.id) {
                processedStockData.id = stockData.id;
            }

            stockData.entries = stockData.entries.filter(entry => {
                return !(entry.count === null && !entry.code);
            });

            if (this.state.modalMode === 'new') {
                await incomingStockService.addIncomingStock(processedStockData);
            } else {
                await incomingStockService.modifyIncomingStock(processedStockData);
            }

            await this.loadIncomingStocks();
            // If a stock was just saved, reload it from API to ensure latest data
            if (stockData.id) {
                const updatedStock = await incomingStockService.getIncomingStock(stockData.id);
                if (updatedStock) {
                    this.setState({ selectedStock: updatedStock });
                }
            }
            this.closeModal();
        } catch (error) {
            console.error('Failed to save incoming stock:', error);
            throw error; // Let modal handle the error display
        }
    }

    closeModal = () => {
        this.setState({
            isModalVisible: false,
            modalMode: 'view'
        });
    }

    openStockById = async (stockId) => {
        try {
            // Find the stock in the current list
            const stock = this.state.incomingStocks.find(s => s.id === stockId);

            if (stock) {
                // Stock found in current list, just open it
                this.setState({
                    selectedStock: stock,
                    isModalVisible: true,
                    modalMode: 'view'
                });
            } else {
                // Stock not in current list, try to load it from API
                const stockData = await incomingStockService.getIncomingStock(stockId);

                if (stockData) {
                    this.setState({
                        selectedStock: stockData,
                        isModalVisible: true,
                        modalMode: 'view'
                    });
                } else {
                }
            }
        } catch (error) {
        }
    }

    printReport = () => {
        window.print();
    }

    // Handle date range changes from parent component
    handleDateRangeChange = (startDate, endDate) => {
        this.applyFilters({
            dateFrom: startDate?.toDate(),
            dateTo: endDate?.toDate()
        });
    }

    // Handle imported data from file upload
    handleImportData = (parsedData) => {
        if (parsedData && parsedData.entries) {
            // Create a new incoming stock with imported entries
            this.setState({
                modalMode: 'new',
                isModalVisible: true,
                selectedStock: {
                    entries: parsedData.entries,
                    supplier: null,
                    date: new Date(),
                    invoice_id: '',
                    delivery_note_id: '',
                    draft: true
                }
            });
        }
    }

    render() {
        const {
            incomingStocks,
            selectedStock,
            isModalVisible,
            modalMode,
            isLoading,
            error,
            filters
        } = this.state;

        return (
            <div className="incoming-stocks-container" style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    {/* Button Bar */}
                    <div className="btn-toolbar buttonbar stocklist-toolbar" style={{
                        width: '100%',
                        paddingLeft: '0rem',
                        paddingRight: '0rem',
                        display: 'flex'
                    }}>
                        <div className="btn-group stocklist-toolbar-group stocklist-toolbar-group--actions" role="group" style={{ width: '100%' }}>
                            <button
                                id="edit"
                                type="button"
                                className="btn btn-primary icon-edit"
                                disabled={!selectedStock}
                                onClick={this.editIncomingStock}
                            >
                                <span className="browser-only">{I18n.t('admin_local.edit')}</span>
                            </button>

                            <button
                                id="add"
                                type="button"
                                className="btn btn-primary icon-plus"
                                onClick={this.newIncomingStock}
                            >
                                <span className="browser-only">{I18n.t('admin_local.add')}</span>
                            </button>

                            <button
                                id="delete"
                                type="button"
                                className="btn btn-danger icon-trash-empty"
                                disabled={!selectedStock}
                                onClick={this.deleteIncomingStock}
                            >
                                <span className="browser-only">{I18n.t('admin_local.delete')}</span>
                            </button>

                            <button
                                id="download"
                                type="button"
                                className="icon-file-excel btn btn-danger"
                                onClick={this.handleDownload}
                            >
                                <span className="browser-only">{I18n.t('admin_local.download_template')}</span>
                            </button>

                            <button
                                id="upload"
                                type="button"
                                className="icon-file-excel btn btn-danger"
                                onClick={this.handleUpload}
                            >
                                <span className="browser-only">{I18n.t('admin_local.upload')}</span>
                            </button>

                            <button
                                id="print"
                                type="button"
                                className="btn btn-primary icon-print"
                                onClick={this.printReport}
                            >
                                <span className="browser-only">{I18n.t('admin_local.print')}</span>
                            </button>
                        </div>
                    </div>

                    {/* Main Table */}
                    <div style={{ flexGrow: 1, overflow: 'hidden' }}>
                        <IncomingStocksTable
                            ref={this.tableRef}
                            incomingStocks={this.getStatusFilteredStocks()}
                            selectedStock={selectedStock}
                            onStockSelect={this.selectStock}
                            onStockDoubleClick={this.editIncomingStock}
                            onFiltersChange={this.applyFilters}
                            filters={filters}
                            isLoading={isLoading}
                            onReload={this.loadIncomingStocks}
                            statusFilter={this.props.statusFilter}
                            online_szamla={this.props.online_szamla}
                            headerLabels={{
                                date: I18n.t('admin_local.date'),
                                supplier: I18n.t('admin_local.supplier'),
                                draft: I18n.t('admin_local.draft'),
                                invoice_id: I18n.t('admin_local.invoice_id'),
                                delivery_note_id: I18n.t('admin_local.delivery_note_id'),
                                entry_count: I18n.t('admin_local.entry_count'),
                                net_price: I18n.t('admin_local.net_price'),
                                entries: I18n.t('admin_local.entries'),
                                other: I18n.t('admin_local.other'),
                            }}
                        />
                    </div>
                </div>

                {/* Modal - Always render but control visibility */}
                <IncomingStockModal
                    ref={this.modalRef}
                    mode={modalMode}
                    stock={selectedStock}
                    onSave={this.saveIncomingStock}
                    onClose={this.closeModal}
                    onOpenStock={this.openStockById}
                    isVisible={isModalVisible}
                    online_szamla={this.props.online_szamla}
                />
                
                {/* Hidden file input for upload functionality - exact replica of original */}
                <input 
                    ref={this.fileInputRef}
                    id="file" 
                    type="file" 
                    style={{ visibility: 'hidden', height: 0, position: 'absolute' }}
                    accept=".xlsx,.xls"
                    onChange={this.handleFileChange}
                />
            </div>
        );
    }

    handleDownload = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        get("adminService/" + localStorage.restaurantSelected + "/getStores").done(stores => {
            get("adminService/" + localStorage.restaurantSelected + "/getStocks").done(stock => {
                // Get menu items from props/store instead of API call
                const ws = window.XLSX.utils.json_to_sheet(this.exportit(menuitemutil.getFlatMenuItems([],this.props.categories).filter(m => m.defaultInventoryItem), stores, stock));

                const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                const excelBuffer = window.XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });

                saveAs(data, auth.myStatus.restaurant_name + "s.xlsx");
            });
        });
    }


    exportit = (array, stores, stocks) => {
    
            const quantities = [];
            stores.forEach(store => {
                quantities.push("s_" + store.name);
            })
            quantities.sort((a, b) => ("" + a).localeCompare("" + b));
            return array.map(m => {
                const path = menuitemutil._getPath(m).split("/");
                getLocale(m.name).split("/").forEach(() => path.pop());
                const iq = m.availableQuantities.find(q => q.quantity == menuitemutil.getInventoryQuantity(m));
                const c = {
                    id: m.id,
                    category: path.join("/"),
                    name: getLocale(m.name),
                    manufacturer: m.manufacturer,
                    label: m.labels.map(l => l.name).join(" / "),
                    quantityType: m.quantityType,
                    "inventory quantity unit": menuitemutil.getInventoryQuantity(m),
                    cost: iq ? iq.cost : 0,
                    vat: ""
                }
                stores.forEach(store => {
                    c["s_" + store.name] = 0;
                })
    
                return c;
            })
        }
}

const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            // Include menu items if available in the store
            categories: props.rootReducer.menuCategories,
        };
    }
    return {};
};


const ForwardedIncomingStocksContainer = React.forwardRef((props, ref) => (
    <IncomingStocksContainer {...props} ref={ref} />
));

export default connect(mapStateToProps)(withRouter(ForwardedIncomingStocksContainer));